<template>
  <div class="modal">
    <div class="shadow" @click="close"></div>
    <div class="content">
      <div class="modal-body" style="width: 300px">
        <span>{{alertMsg}}</span>
      </div>
      <div class="modal-footer" v-if="dialogType == 1">
        <div class="btn btn-success" @click="dialogButtonAction">
          确定
        </div>
      </div>
      <div class="modal-footer" v-else>
        <div class="btn btn-success" @click="dialogCancelButtonAction">
          取消
        </div>
        <div v-if="actionBlock" class="btn btn-success" @click="dialogButtonAction">
          确定
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  export default{
    props: ['dialogType', 'actionBlock', 'cancelBlock', 'alertMsg'],
    data (){
      return {}
    },
    methods: {
      close(){
        this.$dispatch('close-dialog');
      },

      dialogButtonAction () {
        this.close();
        let confirmBl = this.actionBlock;
        if (confirmBl) {
          confirmBl();
        }
      },

      dialogCancelButtonAction () {
        this.close();
        let cancelB = this.cancelBlock;
        if (cancelB) {
          cancelB();
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .modal {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .shadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .content {
    margin-top: 100px;
    z-index: 10001;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 6px;
    background-clip: padding-box;

    .modal-body {
      padding: 20px 0;
      text-align: center;
      font-size: 16px;
      span {
      }
    }

    .modal-footer {

      text-align: center;

      .btn {
        display: inline-block;
        width: 100px;
        margin: 0 10px 10px 10px;
        padding: 5px 0;
        border: 1px solid #5A7AFF;
        border-radius: 5px;
        color: #5A7AFF;

        &.btn-success {
          background-color: #5A7AFF;
          color: #fff;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// AlertDialog.vue?c4d2528c